import { useEffect } from 'react'
import { Sentry } from '@/sentry'
import { useAuth } from '@/stores/authStore'

/**
 * Custom hook to synchronize user context with Sentry
 * Only active in production builds
 */
export function useSentryUser() {
  const { user } = useAuth()

  useEffect(() => {
    if (user) {
      // Set user context in Sentry
      Sentry.setUser({
        id: user.id,
        username: user.username,
        email: user.email,
      })

      // Add additional context as tags
      Sentry.setTag('user_role', user.role)
      Sentry.setTag('user_cabinet', user.cabinet)
      Sentry.setTag('user_language', user.language || 'ar')
      Sentry.setTag('is_admin', user.is_admin ? 'true' : 'false')
    } else {
      // Clear user context on logout
      Sentry.setUser(null)
    }
  }, [user])
}
